const FREE_LIVES_MAX = 5;

export interface LivesState {
  freeLives: number;
  paidLives: number;
  lastResetDate: string;
}

export class LivesService {
  private freeLives = FREE_LIVES_MAX;
  private paidLives = 0;
  private lastResetDate = '';
  private onChange: ((lives: number) => void) | null = null;

  constructor() {
    this.load();
    this.checkDailyReset();
  }

  setOnChange(callback: (lives: number) => void): void {
    this.onChange = callback;
  }

  getTotal(): number {
    return this.freeLives + this.paidLives;
  }

  getFree(): number {
    return this.freeLives;
  }

  getPaid(): number {
    return this.paidLives;
  }

  spendLife(): boolean {
    this.checkDailyReset();

    if (this.freeLives > 0) {
      this.freeLives--;
      this.save();
      this.onChange?.(this.getTotal());
      return true;
    }

    if (this.paidLives > 0) {
      this.paidLives--;
      this.save();
      this.onChange?.(this.getTotal());
      return true;
    }

    return false;
  }

  addPaidLife(amount: number): void {
    this.paidLives += amount;
    this.save();
    this.onChange?.(this.getTotal());
  }

  private checkDailyReset(): void {
    const now = new Date();
    const today = now.toISOString().split('T')[0] ?? '';

    if (today !== this.lastResetDate) {
      this.freeLives = FREE_LIVES_MAX;
      this.lastResetDate = today;
      this.save();
      this.onChange?.(this.getTotal());
    }
  }

  private save(): void {
    const state: LivesState = {
      freeLives: this.freeLives,
      paidLives: this.paidLives,
      lastResetDate: this.lastResetDate,
    };
    localStorage.setItem('hamsters_lives', JSON.stringify(state));
  }

  private load(): void {
    try {
      const data = localStorage.getItem('hamsters_lives');
      if (data) {
        const state: LivesState = JSON.parse(data);
        this.freeLives = state.freeLives;
        this.paidLives = state.paidLives;
        this.lastResetDate = state.lastResetDate;
      }
    } catch {
      // Use defaults
    }
  }
}
